import angular from 'angular';
import uiRouter from 'angular-ui-router';
import compareToDirective from './compareTo.directive';

const compareToModule = angular
  .module('compareTo', [uiRouter])
  .directive('compareTo', compareToDirective).name;

export default compareToModule;



// WEBPACK FOOTER //
// ./client/app/common/compareTo/compareTo.js